import * as React from 'react';
import classnames from 'classnames';
import snakeCase from 'lodash/snakeCase';

import Input from 'components/inputs/input/Input';

import { __t, applyTranslations } from 'utils/language';

import './insights-reports-queries-input-field.scss';

import type { TextEntry } from 'types';
import type { QueryFieldType } from 'modules/insights/reports/types';

applyTranslations(require('modules/insights/reports/components/queries/modals/insights-reports-queries-modal.i18n.json'));
applyTranslations(require('utils/i18n/validators.i18n.json'));

type Props = {
  fieldType: string,
  value: string,
  placeholder?: string,
  autoFocus?: boolean,
  hint?: string,
  hasError?: boolean,
  onChange: (fieldType: QueryFieldType, value: string) => void
};

const MODAL_MSG_KEY = 'insights_reports_queries_modal';

class InsightsReportsQueriesInputField extends React.PureComponent<Props> {
  inputRef: TextEntry | undefined | null = null;

  handleRefCallback = (ref: TextEntry): void => {
    this.inputRef = ref;
  };

  handleChange = (event: React.SyntheticEvent<TextEntry>): void => {
    const { onChange } = this.props;
    const target = event.currentTarget;
    const fieldType = (target.dataset.fieldType || '') as QueryFieldType;
    const value = target.value;

    onChange(fieldType, value);
  };

  renderError(): React.ReactNode {
    const { hasError } = this.props;

    const errorClasses = classnames('insights-reports-queries-input-field__error', {
      'insights-reports-queries-input-field__error--visible': hasError
    });

    return (
      <div className={errorClasses}>
        {__t('validators.required_field')}
      </div>
    );
  }

  renderInput(): React.ReactNode {
    const { fieldType, value, placeholder, autoFocus, hint } = this.props;

    return (
      <Input
        // TODO: Change Input.js `ref` implementation to the newer `createRef` style
        // @ts-ignore - TS doesn't like that `ref` in Input.js can be `null`
        refCallback={this.handleRefCallback}
        type="text"
        name={fieldType}
        value={value}
        width="responsive"
        placeholder={placeholder || __t(`${MODAL_MSG_KEY}.placeholders.${snakeCase(fieldType)}`)}
        autoFocus={autoFocus}
        hint={hint}
        hintAlign="right"
        autoComplete="off"
        className="insights-reports-queries-input-field__input"
        data={{ 'field-type': fieldType }}
        onChange={this.handleChange}
      />
    );
  }

  render(): React.ReactNode {
    return (
      <div className="insights-reports-queries-input-field">
        {this.renderInput()}
        {this.renderError()}
      </div>
    );
  }
}

export default InsightsReportsQueriesInputField;
